import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// @Flow
import { ADD_ERROR, REMOVE_ERROR, READ_ERROR, RESET } from './constants';

var addError = function addError(currentAction, error) {
  return {
    type: ADD_ERROR,
    payload: {
      currentAction: currentAction,
      error: error
    }
  };
};

var removeError = function removeError(currentAction) {
  return {
    type: REMOVE_ERROR,
    payload: {
      currentAction: _objectSpread({
        type: REMOVE_ERROR
      }, currentAction)
    }
  };
};

var setRead = function setRead(error) {
  return {
    type: READ_ERROR,
    payload: {
      error: error
    }
  };
};

var reset = function reset() {
  return {
    type: RESET
  };
};

export default {
  addError: addError,
  removeError: removeError,
  setRead: setRead,
  reset: reset
};
//# sourceMappingURL=error.js.map